const PREFIX = 'Category/';

export const isCategory = (collection: string): boolean => collection.startsWith(PREFIX);

export const parseCategories = (collections?: string[]): string[] => {
  const categories = (collections ?? []).filter((c) => isCategory(c)).map((c) => c.substring(PREFIX.length));
  return categories;
};
